
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance/savings",
      function () {
        return require("private-next-pages/finance/savings.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance/savings"])
      });
    }
  